import firebase from '../../firebaseConfig';
import store from "../../store/storeForBookingApp";

let callback = null;
let metadataRef = null;
console.log('process is', process.env);

// use functions emulator for local dev
if (process.env.NODE_ENV == 'development')
    firebase.functions().useFunctionsEmulator("http://local2.local:5001");
let tryAddAnyRoles = firebase.functions().httpsCallable("addRoles");

export function onAuthStateChanged() {
    let qsParams = (new URL(location)).searchParams;
    let isDemoMode = qsParams.get("isSneosAdminDemo");

    firebase.auth().onAuthStateChanged((user) => {
        // Remove previous listener.
        if (callback) {
            metadataRef.off('value', callback);
        }
        // On user login add new listener.
        if (user) {
            // User is signed in.
            console.log("// User is signed in.", user);

            // Check if refresh is required.
            metadataRef = firebase.database().ref('metadata/' + user.uid + '/refreshTime');
            callback = () => {

                // Force refresh to pick up the latest custom claims changes.
                // Note this is always triggered on first call. Further optimization could be
                // added to avoid the initial trigger when the token is issued and already contains
                // the latest claims.
                user.getIdTokenResult(true).then((idTokenResult) => {
                    // User is signed in again.
                    store.dispatch('auth/signIn', user, idTokenResult.claims);
                })
                    .catch((error) => {
                        console.log(error);

                    });
            };
            // Subscribe new listener to changes on that node.
            metadataRef.on('value', callback);
            console.log("tryAddAnyRoles is called, ", new Date());
            tryAddAnyRoles({
                email: user.email,
                url: window.location.hostname,
                isDemoAdmin: isDemoMode
            });
            // demo mode param is turned off after first login
            isDemoMode = false;
        }

        //TODO add admmin role to existing non admin user
        // if (user) {
        //     // User is signed in.
        //     console.log("// User is signed in.", user);

        //     // Check and add any user claims
        //     tryAddAnyRoles({
        //         email: user.email,
        //         url: window.location.hostname,
        //     });
        //     // }).then((idTokenResult) => {
        //     //     eventBus.$store.state.auth.(user, idTokenResult);
        //     // });
        // } else {
        //     // No user is signed in.

        //     console.log("// No user is signed in.");
        // }
    });
} 
